import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import TimeAgo from 'react-timeago'
import PropTypes from 'prop-types'

import FaComment from 'react-icons/fa/comment'
import FaBookmarkYes from 'react-icons/fa/bookmark'
import FaBookmarkNo from 'react-icons/fa/bookmark-o'
import FaTag from 'react-icons/fa/tag'

@autobind
class WorkTile extends Component {
  onBookmark (e) {
    e.preventDefault()
    this.props.onBookmark(this.props)
  }

  render () {
    var description = this.props.description && this.props.description.length > 100
      ? this.props.description.substring(0, 100) + '...'
      : this.props.description

    var tags = this.props.tags && this.props.tags.length ? <div className='work__tags'><FaTag /> {this.props.tags.join(', ')}</div> : ''

    return (
      <article className='work tile'>
        <div className='tile__image'>
          {this.props.media.length && <img width={this.props.media[0].width} height={this.props.media[0].height} src={this.props.media[0].thumb_url + '?v=' + Date.now()} />}
        </div>
        <div className='tile__body'>
          <span className={`work__year year year--${this.props.year_group.order}`}>{this.props.year_group.title}</span>
          <h2 className='tile__title'>{this.props.title}</h2>
          <div className='work__author'>{this.props.school.title}</div>
          <div className='work__desc tile__desc'>{description}</div>
          {tags}
        </div>
        <div className='work__footer tile__footer'>
          <div className='work__date'><TimeAgo date={this.props.created_at} /></div>
          {this.props.has_commented && <FaComment />}
          <div className='work__bookmark' onClick={this.onBookmark}>
            {this.props.bookmarked_by_me ? <FaBookmarkYes /> : <FaBookmarkNo />}
          </div>
        </div>
      </article>
    )
  }
}

WorkTile.propTypes = {
  description: PropTypes.string,
  has_commented: PropTypes.bool,
  bookmarked_by_me: PropTypes.bool,
  media: PropTypes.array,
  school: PropTypes.object,
  student: PropTypes.object,
  tags: PropTypes.array,
  title: PropTypes.string,
  year_group: PropTypes.object,
  onBookmark: PropTypes.func
}

export default WorkTile



// WEBPACK FOOTER //
// ./components/search/WorkTile.js